import React, { Component } from 'react';
import { RaisedButton, Divider, FlatButton, Dialog } from 'material-ui';
import moment from 'moment';
import { Player, BigPlayButton } from 'video-react'
import IconButton from 'material-ui/IconButton';
import Clear from 'material-ui/svg-icons/content/clear';
import { getTimeFromSeconds } from "../../lib/recordHelpers"

import "video-react/dist/video-react.css"; 

import { showAllRecordings, deleteFile, getFileBlob } from '../../lib/IndexedDB';
import { bytesToSize } from '../../lib/lib';

const buttonStyle = {
  borderRadius: 40
};

class ListItem extends Component{
  constructor(props) {
    super(props);

    this.state = {
      isSaving: false,
    };
  }

  getFileName = (date, roomName) => {
    const fileName = `${moment(date).format('YYYY-MM-DD HH:mm:ss')}_${roomName}`;
    return fileName.replace(new RegExp(':', 'g'), '_').replace(new RegExp(' ', 'g'), '_');
  }

  handleDownloadBlob = () => {
    const { id, roomName, date } = this.props;
    const fileName = this.getFileName(date, roomName);
    getFileBlob(id, (blob) => {
      const url = window.URL.createObjectURL(blob);
      this.link.style = "display: none;";
      this.link.href = url;
      this.link.download = `${fileName}.webm`;
      return this.link.click();
    })
  }

  render() {
    const { id, file, date, onDelete, roomName, url, duration } = this.props;
    const { isSaving } = this.state;
    return (
      <div>
        <div className="mb3 mt3">
          <div className="flex">
            <div 
              style={{
                width: 240,
                height: 135,
                paddingRight: 8
              }}
            >
              <Player
                src={url}
              >
                <BigPlayButton position="center" />
              </Player>
            </div>
            <div className="flex justify-between flex-column">
              <div>
                <div className="mb2">{roomName}</div>
                <div className="gray">
                  <span>{moment(date).format('LLL')}, </span>
                  <span>{bytesToSize(file.size)}</span>
                  {
                    duration && (
                      <span>, {getTimeFromSeconds(duration)}</span>
                    )
                  }
                </div>
              </div>
              <div className="flex justify-between">
                <RaisedButton
                  style={buttonStyle}
                  primary={true}
                  label={isSaving ? "Saving..." : "Save"}
                  disabled={isSaving}
                  buttonStyle={buttonStyle}
                  onClick={() => this.handleDownloadBlob()}
                />
                <FlatButton
                  labelStyle={{ color: '#ff4869' }}
                  style={buttonStyle}
                  label="delete"
                  onClick={() => onDelete(id)}
                />
              </div>
            </div>
          </div>
          
          <a ref={c => { this.link = c; }} href="#" />
        </div>
        <Divider />
      </div>
    )
  }
}

class Recordings extends Component {
  video = null;
  state = {
    recordings: [],
    videoURL: null,
    open: false,
    selectedFileName: ""
  }
  componentDidMount() {
    showAllRecordings((recordings) => {
      this.setState({ recordings });
    });
  }

  handleDelete = key => {
    deleteFile(key, recordings => this.setState({ recordings }));
  }

  playVideo = (key, fileName) => {
    getFileBlob(key, (blob) => {
      const url = window.URL.createObjectURL(blob);
      // this.video.src = url;
      // this.video.play();
      this.setState({ videoURL: url, open: true, selectedFileName: fileName });
    })
  }

  getFileName = (date, roomName) => {
    const fileName = `${moment(date).format('YYYY-MM-DD HH:mm:ss')}_${roomName}`;
    return fileName.replace(new RegExp(':', 'g'), '_').replace(new RegExp(' ', 'g'), '_');
  }

  isRecordingsNotEmpty = () => {
    const { recordings } = this.state;
    if (recordings === null || recordings === undefined || !Array.isArray(recordings) || recordings.length === 0) {
      return false;
    }
    return true;
  }

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const { videoURL, open, selectedFileName } = this.state;
    let { recordings } = this.state;
    recordings =  recordings.sort((a, b) => new Date(b.data.date) - new Date(a.data.date));
    return (
      <div style={{ minHeight: 'inherit' }} className="h-100 w-100 flex justify-center items-center flex-column">
        <div className="w-34">
          <div className="mb3">
            <h4 className="tc">ローカル録画リスト</h4>
            {false && "Please save your recordings. We can not guarantee how long your browser will store your recordings for."}
          </div>
          <Divider />
          <div style={{ height: 500, overflowY: 'auto' }} >
            {this.isRecordingsNotEmpty() ? recordings.map(file => (
              <ListItem
                key={file.id}
                id={file.id}
                onDelete={(key) => this.handleDelete(key)}
                url={file.url}
                playVideo={this.playVideo}
                {...file.data}
              />
            )) : 'No recordings found!!'}
          </div>
          {this.isRecordingsNotEmpty() && (
            <div className="flex justify-end mt3">
              <FlatButton
                labelStyle={{ color: '#ff4869' }}
                style={buttonStyle}
                label="delete all"
                onClick={() => {
                  deleteFile('all', recordings => this.setState({ recordings }))
                }}
              />
            </div>
          )}
        </div>
          <Dialog
            modal={false}
            open={open}
            onRequestClose={this.handleClose}
          >
          <div className="flex justify-between mb3">
            <h3>
              {selectedFileName}
            </h3>
            <IconButton onClick={this.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear />
            </IconButton>
          </div>
            <Player src={videoURL}>
              <BigPlayButton position="center" />
            </Player>
          </Dialog>
      </div>
    )
  }
}

export default Recordings;



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/Recordings.js